// protolint:disable REPEATED_FIELD_NAMES_PLURALIZED

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file common/v1/events.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any, AnyJson, MessageOptions, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_descriptor, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v1/events.proto.
 */
export const file_common_v1_events: GenFile =
	/*@__PURE__*/
	fileDesc("ChZjb21tb24vdjEvZXZlbnRzLnByb3RvEgljb21tb24udjEiCgoITWV0YWRhdGEilgEKBUV2ZW50EhAKCGV2ZW50X2lkGAEgASgJEiUKCG1ldGFkYXRhGAIgASgLMhMuY29tbW9uLnYxLk1ldGFkYXRhEiUKB3BheWxvYWQYAyABKAsyFC5nb29nbGUucHJvdG9idWYuQW55Ei0KCXRpbWVzdGFtcBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXA6OgoFZXZlbnQSHy5nb29nbGUucHJvdG9idWYuTWVzc2FnZU9wdGlvbnMY0YYDIAEoCFIFZXZlbnSIAQFiBnByb3RvMw", [
		file_google_protobuf_any,
		file_google_protobuf_descriptor,
		file_google_protobuf_timestamp,
	]);

/**
 * @generated from message common.v1.Metadata
 */
export type Metadata = Message<"common.v1.Metadata"> & {};

/**
 * @generated from message common.v1.Metadata
 */
export type MetadataJson = {};

/**
 * Describes the message common.v1.Metadata.
 * Use `create(MetadataSchema)` to create a new message.
 */
export const MetadataSchema: GenMessage<Metadata, { jsonType: MetadataJson }> = /*@__PURE__*/ messageDesc(file_common_v1_events, 0);

/**
 * @generated from message common.v1.Event
 */
export type Event = Message<"common.v1.Event"> & {
	/**
	 * @generated from field: string event_id = 1;
	 */
	eventId: string;

	/**
	 * @generated from field: common.v1.Metadata metadata = 2;
	 */
	metadata?: Metadata | undefined;

	/**
	 * @generated from field: google.protobuf.Any payload = 3;
	 */
	payload?: Any | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 4;
	 */
	timestamp?: Timestamp | undefined;
};

/**
 * @generated from message common.v1.Event
 */
export type EventJson = {
	/**
	 * @generated from field: string event_id = 1;
	 */
	eventId?: string;

	/**
	 * @generated from field: common.v1.Metadata metadata = 2;
	 */
	metadata?: MetadataJson;

	/**
	 * @generated from field: google.protobuf.Any payload = 3;
	 */
	payload?: AnyJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 4;
	 */
	timestamp?: TimestampJson;
};

/**
 * Describes the message common.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event, { jsonType: EventJson }> = /*@__PURE__*/ messageDesc(file_common_v1_events, 1);

/**
 * @generated from extension: optional bool event = 50001;
 */
export const event: GenExtension<MessageOptions, boolean> = /*@__PURE__*/ extDesc(file_common_v1_events, 0);
